import { createSelector } from 'reselect';

import { getCurrentLiveStreamSlice } from './common-selectors';

import { MODAL_TYPE } from '../../components/popups/modal-wrapper/variables';

export const getStreamIframlessModal = createSelector(
    getCurrentLiveStreamSlice,
    ({ streamIframlessModal }) => streamIframlessModal
);

export const getStreamModal = (name) => {
    switch (name) {
        case MODAL_TYPE.STREAM_IFRAMLESS_MODAL:
            return getStreamIframlessModal;
        default:
            throw new Error(`Unknown selector name: ${name}`);
    }
};
